"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trybe
 * This site provides documentation on how to use the Trybe Shop API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var ReportsApi = /** @class */ (function (_super) {
    __extends(ReportsApi, _super);
    function ReportsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This endpoint queues an export of intake forms for the given basket IDs.
     * Export intake forms queue
     */
    ReportsApi.prototype.actionQueueIntakeFormsExportRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.siteId !== undefined) {
                            queryParameters['site_id'] = requestParameters.siteId;
                        }
                        if (requestParameters.basketIds) {
                            queryParameters['basket_ids'] = requestParameters.basketIds.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/visit-intake-forms-for-orders/queue-pdf",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.QueuedJobResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint queues an export of intake forms for the given basket IDs.
     * Export intake forms queue
     */
    ReportsApi.prototype.actionQueueIntakeFormsExport = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actionQueueIntakeFormsExportRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This endpoint queues an export of the projected membership revenue by month report.
     * Queue an export of the projected membership revenue by month report
     */
    ReportsApi.prototype.actionQueueProjectedMembershipRevenueByMonthReportRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
                            throw new runtime.RequiredError('siteId', 'Required parameter requestParameters.siteId was null or undefined when calling actionQueueProjectedMembershipRevenueByMonthReport.');
                        }
                        if (requestParameters.date === null || requestParameters.date === undefined) {
                            throw new runtime.RequiredError('date', 'Required parameter requestParameters.date was null or undefined when calling actionQueueProjectedMembershipRevenueByMonthReport.');
                        }
                        queryParameters = {};
                        if (requestParameters.siteId !== undefined) {
                            queryParameters['site_id'] = requestParameters.siteId;
                        }
                        if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date.toISOString().substr(0, 10);
                        }
                        if (requestParameters.membershipTypeIds) {
                            queryParameters['membership_type_ids'] = requestParameters.membershipTypeIds.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.billingFrequency) {
                            queryParameters['billing_frequency'] = requestParameters.billingFrequency.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.manualPayments !== undefined) {
                            queryParameters['manual_payments'] = requestParameters.manualPayments;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/reports/projected-membership-revenue-by-month/queue",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.QueuedJobResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint queues an export of the projected membership revenue by month report.
     * Queue an export of the projected membership revenue by month report
     */
    ReportsApi.prototype.actionQueueProjectedMembershipRevenueByMonthReport = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actionQueueProjectedMembershipRevenueByMonthReportRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This endpoint queues an export of the projected membership revenue report.
     * Queue an export of the projected membership revenue report
     */
    ReportsApi.prototype.actionQueueProjectedMembershipRevenueReportRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
                            throw new runtime.RequiredError('siteId', 'Required parameter requestParameters.siteId was null or undefined when calling actionQueueProjectedMembershipRevenueReport.');
                        }
                        if (requestParameters.date === null || requestParameters.date === undefined) {
                            throw new runtime.RequiredError('date', 'Required parameter requestParameters.date was null or undefined when calling actionQueueProjectedMembershipRevenueReport.');
                        }
                        queryParameters = {};
                        if (requestParameters.siteId !== undefined) {
                            queryParameters['site_id'] = requestParameters.siteId;
                        }
                        if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date.toISOString().substr(0, 10);
                        }
                        if (requestParameters.membershipTypeIds) {
                            queryParameters['membership_type_ids'] = requestParameters.membershipTypeIds.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.billingFrequency) {
                            queryParameters['billing_frequency'] = requestParameters.billingFrequency.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.manualPayments !== undefined) {
                            queryParameters['manual_payments'] = requestParameters.manualPayments;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/reports/projected-membership-revenue/queue",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.QueuedJobResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint queues an export of the projected membership revenue report.
     * Queue an export of the projected membership revenue report
     */
    ReportsApi.prototype.actionQueueProjectedMembershipRevenueReport = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actionQueueProjectedMembershipRevenueReportRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This endpoint queues an export of the service charge items report.
     * Queue an export of the service charge items report
     */
    ReportsApi.prototype.actionQueueServiceChargeItemsReportRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.siteId !== undefined) {
                            queryParameters['site_id'] = requestParameters.siteId;
                        }
                        if (requestParameters.offeringType !== undefined) {
                            queryParameters['offering_type'] = requestParameters.offeringType;
                        }
                        if (requestParameters.offeringId) {
                            queryParameters['offering_id'] = requestParameters.offeringId.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.offeringCategory !== undefined) {
                            queryParameters['offering_category'] = requestParameters.offeringCategory;
                        }
                        if (requestParameters.soldById) {
                            queryParameters['sold_by_id'] = requestParameters.soldById.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.orderStatus !== undefined) {
                            queryParameters['order_status'] = requestParameters.orderStatus;
                        }
                        if (requestParameters.status !== undefined) {
                            queryParameters['status'] = requestParameters.status;
                        }
                        if (requestParameters.dateFrom !== undefined) {
                            queryParameters['date_from'] = requestParameters.dateFrom.toISOString().substr(0, 10);
                        }
                        if (requestParameters.dateTo !== undefined) {
                            queryParameters['date_to'] = requestParameters.dateTo.toISOString().substr(0, 10);
                        }
                        if (requestParameters.revenueDateFrom !== undefined) {
                            queryParameters['revenue_date_from'] = requestParameters.revenueDateFrom.toISOString().substr(0, 10);
                        }
                        if (requestParameters.revenueDateTo !== undefined) {
                            queryParameters['revenue_date_to'] = requestParameters.revenueDateTo.toISOString().substr(0, 10);
                        }
                        if (requestParameters.orderSubmittedAtFrom !== undefined) {
                            queryParameters['order_submitted_at_from'] = requestParameters.orderSubmittedAtFrom.toISOString().substr(0, 10);
                        }
                        if (requestParameters.orderSubmittedAtTo !== undefined) {
                            queryParameters['order_submitted_at_to'] = requestParameters.orderSubmittedAtTo.toISOString().substr(0, 10);
                        }
                        if (requestParameters.orderLabel !== undefined) {
                            queryParameters['order_label'] = requestParameters.orderLabel;
                        }
                        if (requestParameters.itemDateFrom !== undefined) {
                            queryParameters['item_date_from'] = requestParameters.itemDateFrom.toISOString().substr(0, 10);
                        }
                        if (requestParameters.itemDateTo !== undefined) {
                            queryParameters['item_date_to'] = requestParameters.itemDateTo.toISOString().substr(0, 10);
                        }
                        if (requestParameters.practitionerId) {
                            queryParameters['practitioner_id'] = requestParameters.practitionerId.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.roomId) {
                            queryParameters['room_id'] = requestParameters.roomId.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.zoneId) {
                            queryParameters['zone_id'] = requestParameters.zoneId.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/reports/service-charge-items/queue",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.QueuedJobResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint queues an export of the service charge items report.
     * Queue an export of the service charge items report
     */
    ReportsApi.prototype.actionQueueServiceChargeItemsReport = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actionQueueServiceChargeItemsReportRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This endpoint queues an export of a full day\'s itinerary for a given date.
     * Date Itinerary Report Queue
     */
    ReportsApi.prototype.getDateItineraryQueueRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date.toISOString().substr(0, 10);
                        }
                        if (requestParameters.siteId !== undefined) {
                            queryParameters['site_id'] = requestParameters.siteId;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/reports/itinerary",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.QueuedJobResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint queues an export of a full day\'s itinerary for a given date.
     * Date Itinerary Report Queue
     */
    ReportsApi.prototype.getDateItineraryQueue = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDateItineraryQueueRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve the projected revenue from `Memberships` at a given date
     * List projected revenues for memberships
     */
    ReportsApi.prototype.listProjectedMembershipRevenueRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
                            throw new runtime.RequiredError('siteId', 'Required parameter requestParameters.siteId was null or undefined when calling listProjectedMembershipRevenue.');
                        }
                        if (requestParameters.date === null || requestParameters.date === undefined) {
                            throw new runtime.RequiredError('date', 'Required parameter requestParameters.date was null or undefined when calling listProjectedMembershipRevenue.');
                        }
                        queryParameters = {};
                        if (requestParameters.siteId !== undefined) {
                            queryParameters['site_id'] = requestParameters.siteId;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date.toISOString().substr(0, 10);
                        }
                        if (requestParameters.membershipTypeIds) {
                            queryParameters['membership_type_ids'] = requestParameters.membershipTypeIds.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.billingFrequency) {
                            queryParameters['billing_frequency'] = requestParameters.billingFrequency.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.manualPayments !== undefined) {
                            queryParameters['manual_payments'] = requestParameters.manualPayments;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/reports/projected-membership-revenue",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ListProjectedMembershipRevenueResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve the projected revenue from `Memberships` at a given date
     * List projected revenues for memberships
     */
    ReportsApi.prototype.listProjectedMembershipRevenue = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listProjectedMembershipRevenueRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve the projected revenue from `Memberships` at a given date for the following 12 calendar months
     * List projected revenues by month for memberships
     */
    ReportsApi.prototype.listProjectedMembershipRevenueByMonthRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.siteId === null || requestParameters.siteId === undefined) {
                            throw new runtime.RequiredError('siteId', 'Required parameter requestParameters.siteId was null or undefined when calling listProjectedMembershipRevenueByMonth.');
                        }
                        if (requestParameters.date === null || requestParameters.date === undefined) {
                            throw new runtime.RequiredError('date', 'Required parameter requestParameters.date was null or undefined when calling listProjectedMembershipRevenueByMonth.');
                        }
                        queryParameters = {};
                        if (requestParameters.siteId !== undefined) {
                            queryParameters['site_id'] = requestParameters.siteId;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date.toISOString().substr(0, 10);
                        }
                        if (requestParameters.membershipTypeIds) {
                            queryParameters['membership_type_ids'] = requestParameters.membershipTypeIds.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.billingFrequency) {
                            queryParameters['billing_frequency'] = requestParameters.billingFrequency.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.manualPayments !== undefined) {
                            queryParameters['manual_payments'] = requestParameters.manualPayments;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/reports/projected-membership-revenue-by-month",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ListProjectedMembershipRevenueByMonthResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve the projected revenue from `Memberships` at a given date for the following 12 calendar months
     * List projected revenues by month for memberships
     */
    ReportsApi.prototype.listProjectedMembershipRevenueByMonth = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listProjectedMembershipRevenueByMonthRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve a paginated list of basket items with their service charge amounts.
     * List service charge items
     */
    ReportsApi.prototype.listServiceChargeItemsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.siteId !== undefined) {
                            queryParameters['site_id'] = requestParameters.siteId;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.offeringType !== undefined) {
                            queryParameters['offering_type'] = requestParameters.offeringType;
                        }
                        if (requestParameters.offeringId) {
                            queryParameters['offering_id'] = requestParameters.offeringId.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.offeringCategory !== undefined) {
                            queryParameters['offering_category'] = requestParameters.offeringCategory;
                        }
                        if (requestParameters.soldById) {
                            queryParameters['sold_by_id'] = requestParameters.soldById.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.orderStatus !== undefined) {
                            queryParameters['order_status'] = requestParameters.orderStatus;
                        }
                        if (requestParameters.status !== undefined) {
                            queryParameters['status'] = requestParameters.status;
                        }
                        if (requestParameters.dateFrom !== undefined) {
                            queryParameters['date_from'] = requestParameters.dateFrom.toISOString().substr(0, 10);
                        }
                        if (requestParameters.dateTo !== undefined) {
                            queryParameters['date_to'] = requestParameters.dateTo.toISOString().substr(0, 10);
                        }
                        if (requestParameters.revenueDateFrom !== undefined) {
                            queryParameters['revenue_date_from'] = requestParameters.revenueDateFrom.toISOString().substr(0, 10);
                        }
                        if (requestParameters.revenueDateTo !== undefined) {
                            queryParameters['revenue_date_to'] = requestParameters.revenueDateTo.toISOString().substr(0, 10);
                        }
                        if (requestParameters.orderSubmittedAtFrom !== undefined) {
                            queryParameters['order_submitted_at_from'] = requestParameters.orderSubmittedAtFrom.toISOString().substr(0, 10);
                        }
                        if (requestParameters.orderSubmittedAtTo !== undefined) {
                            queryParameters['order_submitted_at_to'] = requestParameters.orderSubmittedAtTo.toISOString().substr(0, 10);
                        }
                        if (requestParameters.orderLabel !== undefined) {
                            queryParameters['order_label'] = requestParameters.orderLabel;
                        }
                        if (requestParameters.itemDateFrom !== undefined) {
                            queryParameters['item_date_from'] = requestParameters.itemDateFrom.toISOString().substr(0, 10);
                        }
                        if (requestParameters.itemDateTo !== undefined) {
                            queryParameters['item_date_to'] = requestParameters.itemDateTo.toISOString().substr(0, 10);
                        }
                        if (requestParameters.practitionerId) {
                            queryParameters['practitioner_id'] = requestParameters.practitionerId.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.roomId) {
                            queryParameters['room_id'] = requestParameters.roomId.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.zoneId) {
                            queryParameters['zone_id'] = requestParameters.zoneId.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/reports/service-charge-items",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ListServiceChargeItemsResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve a paginated list of basket items with their service charge amounts.
     * List service charge items
     */
    ReportsApi.prototype.listServiceChargeItems = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listServiceChargeItemsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return ReportsApi;
}(runtime.BaseAPI));
exports.ReportsApi = ReportsApi;
/**
    * @export
    * @enum {string}
    */
var ActionQueueProjectedMembershipRevenueByMonthReportBillingFrequencyEnum;
(function (ActionQueueProjectedMembershipRevenueByMonthReportBillingFrequencyEnum) {
    ActionQueueProjectedMembershipRevenueByMonthReportBillingFrequencyEnum["P1M"] = "P1M";
    ActionQueueProjectedMembershipRevenueByMonthReportBillingFrequencyEnum["P3M"] = "P3M";
    ActionQueueProjectedMembershipRevenueByMonthReportBillingFrequencyEnum["P6M"] = "P6M";
    ActionQueueProjectedMembershipRevenueByMonthReportBillingFrequencyEnum["P1Y"] = "P1Y";
})(ActionQueueProjectedMembershipRevenueByMonthReportBillingFrequencyEnum = exports.ActionQueueProjectedMembershipRevenueByMonthReportBillingFrequencyEnum || (exports.ActionQueueProjectedMembershipRevenueByMonthReportBillingFrequencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ActionQueueProjectedMembershipRevenueReportBillingFrequencyEnum;
(function (ActionQueueProjectedMembershipRevenueReportBillingFrequencyEnum) {
    ActionQueueProjectedMembershipRevenueReportBillingFrequencyEnum["P1M"] = "P1M";
    ActionQueueProjectedMembershipRevenueReportBillingFrequencyEnum["P3M"] = "P3M";
    ActionQueueProjectedMembershipRevenueReportBillingFrequencyEnum["P6M"] = "P6M";
    ActionQueueProjectedMembershipRevenueReportBillingFrequencyEnum["P1Y"] = "P1Y";
})(ActionQueueProjectedMembershipRevenueReportBillingFrequencyEnum = exports.ActionQueueProjectedMembershipRevenueReportBillingFrequencyEnum || (exports.ActionQueueProjectedMembershipRevenueReportBillingFrequencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ListProjectedMembershipRevenueBillingFrequencyEnum;
(function (ListProjectedMembershipRevenueBillingFrequencyEnum) {
    ListProjectedMembershipRevenueBillingFrequencyEnum["P1M"] = "P1M";
    ListProjectedMembershipRevenueBillingFrequencyEnum["P3M"] = "P3M";
    ListProjectedMembershipRevenueBillingFrequencyEnum["P6M"] = "P6M";
    ListProjectedMembershipRevenueBillingFrequencyEnum["P1Y"] = "P1Y";
})(ListProjectedMembershipRevenueBillingFrequencyEnum = exports.ListProjectedMembershipRevenueBillingFrequencyEnum || (exports.ListProjectedMembershipRevenueBillingFrequencyEnum = {}));
/**
    * @export
    * @enum {string}
    */
var ListProjectedMembershipRevenueByMonthBillingFrequencyEnum;
(function (ListProjectedMembershipRevenueByMonthBillingFrequencyEnum) {
    ListProjectedMembershipRevenueByMonthBillingFrequencyEnum["P1M"] = "P1M";
    ListProjectedMembershipRevenueByMonthBillingFrequencyEnum["P3M"] = "P3M";
    ListProjectedMembershipRevenueByMonthBillingFrequencyEnum["P6M"] = "P6M";
    ListProjectedMembershipRevenueByMonthBillingFrequencyEnum["P1Y"] = "P1Y";
})(ListProjectedMembershipRevenueByMonthBillingFrequencyEnum = exports.ListProjectedMembershipRevenueByMonthBillingFrequencyEnum || (exports.ListProjectedMembershipRevenueByMonthBillingFrequencyEnum = {}));
